// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2HCzg","title":"Images45_title__1ahbh","images":"Images45_images__1Jt83"};